export const DISMISS_ALERT = 'DISMISS_ALERT';
